import script from "./HandleFriendshipDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./HandleFriendshipDrawer.vue?vue&type=script&setup=true&lang=js"

import "./HandleFriendshipDrawer.vue?vue&type=style&index=0&id=2420cffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2420cffc"]])

export default __exports__